<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form ref="form"
               :model="form"
               :rules="rules"
               style="width: 90%"
               label-width="110px"
               size="small">
        <el-row>

          <el-col :span="6">
            <el-form-item prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="title"
                          label="商品名">
              <el-input v-model="form.title"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="prdType"
                          label="商品类型">
              <el-input v-model="form.prdType"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platTitle"
                          label="平台商品名">
              <el-input v-model="form.platTitle"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="category1"
                          label="商品一级分类">
              <el-input v-model="form.category1"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="skuCode"
                          label="SKU">
              <el-input v-model="form.skuCode"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="spuCode"
                          label="SPU">
              <el-input v-model="form.spuCode"
                        clearable
                        style="width: 90%"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <el-row>
        <el-col :span="12">
          <el-button type="primary"
                     size="medium"
                     :loading="loading"
                     icon="el-icon-search"
                     @click="handleSearch">搜索</el-button>
          <el-button @click="clearSearch"
                     size="medium"
                     icon="el-icon-refresh">重置</el-button>
          <el-button @click="importShow"
                     type="success"
                     size="medium"
                     icon="el-icon-upload el-icon--right">导入</el-button>
        </el-col>
        <el-col style="text-align: right;"
                :span="12">
          <el-select v-model="actForm.seloption"
                     size="medium"
                     clearable
                     placeholder="请选择...">
            <el-option v-for="item in selOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
          <el-button type="primary"
                     size="medium"
                     :loading="distoryloading"
                     @click="actOrd">应用</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-table v-loading="loading"
              class="main-table"
              ref="multipleTable"
              border
              @selection-change="handleSelectionChange"
              :data="tableData"
              @cell-dblclick="showInfo">
      <el-table-column type="selection"
                       width="55">
      </el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="shopCode"
                       label="店铺"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="skuCode"
                       label="SKU">

        <template slot-scope="scope">
          <el-button type="text"
                     @click="showInfo(scope.row)">{{
            scope.row.skuCode
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="title"
                       label="商品名"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="prdType"
                       label="商品类型"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="category1"
                       label="商品一级分类"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="category2"
                       label="商品二级分类"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="updated_at"
                       label="更新时间"
                       width="220px">
        <template slot-scope="scope">
          {{
          scope.row.updated_at | parseTime
          }}</template>
      </el-table-column>
    </el-table>
    <el-card style="padding:0"
             class="pagation-card">
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-simple @submit="handleFile"
                   ref="refImportDialog" />

    <!-- 详情弹出框 -->
    <el-dialog title="主档详情"
               :visible.sync="dialogInfoFormVisible"
               @close="closeInfoDialog">
      <el-form :model="infoForm"
               label-width="110px"
               class="form-inline">
        <el-row class="dialog-row"
                :gutter="20">
          <el-col :span="12">
            <el-form-item prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="infoForm.profession"
                         placeholder="请选择"
                         style="width: 90%"
                         :disabled="true">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="infoForm.business"
                         placeholder="请选择"
                         style="width: 90%"
                         :disabled="true">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="infoForm.store"
                         placeholder="请选择"
                         style="width: 90%"
                         :disabled="true">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="价格">
              <el-input v-model="infoForm.price"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="SKU">
              <el-input v-model="infoForm.skuCode"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="SPU">
              <el-input v-model="infoForm.spuCode"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="商品名">
              <el-input v-model="infoForm.title"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="平台商品名">
              <el-input v-model="infoForm.platTitle"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="title"
                          label="商品类型">
              <el-input v-model="infoForm.prdType"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="prdModel"
                          label="商品型号">
              <el-input v-model="infoForm.title"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="商品一级分类">
              <el-input v-model="infoForm.category1"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="title"
                          label="商品二级分类">
              <el-input v-model="infoForm.category2"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="created_at"
                          label="创建时间">
              <el-input clearable
                        v-model="infoForm.created_at"
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="updated_at"
                          label="更新时间">
              <el-input v-model="infoForm.updated_at"
                        clearable
                        style="width: 90%"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           align="center">
        <el-button @click="dialogInfoFormVisible = false"
                   size="medium"
                   type="primary">关闭</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import XLSX from 'xlsx'
// import SearchMixin from '@/common/mixins/search-mixin'
import { dealReturn } from '@/common/js/index.js'
import importSimple from '@/base/rfmImportDialog'
import { parseTime } from '@/utils/index'

import { numberCompare, isNumber } from '@/utils'
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/rfmselect'
// import { tradelist_api } from './desc'
import * as Desc from './desc.js'
import { form, rules } from './data'
export default {
  mixins: [
    getplatlists,
    getptnlists,
    getshoplists,
    gettradestatus,
    gettradefrom,
  ],
  components: { importSimple },
  data() {
    return {
      form: {
        business: '',
        store: '',
        profession: '',
        spuCode: '',
        skuCode: '',
        title: '',
        platTitle: '',
        prdType: '',
      },
      platlists: [],
      loading: false,
      tableData: [],
      fileList: [],
      provinceList: [],
      Desc,
      rules,
      exportForm: {},
      multipleSelection: [],
      infoForm: {},
      dialogInfoFormVisible: false,
      // payment1: "",
      // payment2: "",
      queryPrdlists: {
        param: {},
        query: {},
        pagenum: 1,
        pagesize: 20,
        reportname: null, // 当前“模块” 路由
      },
      actForm: {
        id: [],
        seloption: '',
      },
      selOptions: [{ value: 'delete', label: '删除' }],
      distoryloading: false,
      currentPage: 1, // 分页
      total: 0, // 分页
    }
  },
  created() {
    console.log('111', this.form)
    this.getTableData()
  },
  methods: {
    closeInfoDialog() {
      this.infoForm = {}
    },
    showInfo(row) {
      let copy = Object.assign({}, row)
      copy.created_at = parseTime(copy.created_at)
      copy.updated_at = parseTime(copy.updated_at)
      this.infoForm = copy

      this.dialogInfoFormVisible = true
    },
    importShow() {
      this.$refs.refImportDialog.show()
    },
    async handleFile(form) {
      // debugger;
      console.log(form)

      let { data, err } = await this.axiosApi(Desc.upload_api, form)
      console.log(data)
      if (data && data.status === 200) {
        this.getTableData()
        let type =
          data.data &&
          (data.data.data.result || data.data.data.indexOf('未完成') == -1)
            ? 'success'
            : 'error'
        this.$message({
          type: type,
          message: data.data && data.data.data ? data.data.data : '',
          // offset: 61
        })
      } else {
        dealReturn(data, err)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    async actOrd() {
      // console.log(this.multipleSelection)
      console.log(this.actForm, this.multipleSelection)

      this.actForm.id = []
      this.actForm.id = this.multipleSelection.map((item) => {
        return item.id
      })
      console.log(this.actForm.id)
      // 未选择提示
      if (this.multipleSelection.length == 0) {
        return this.$message.error('请先选择商品')
      }

      // 未选择执行操作提示
      if (!this.actForm.seloption) {
        return this.$message.error('请选择要执行的操作')
      }

      console.log(this.actForm, this.multipleSelection)
      if (this.actForm.seloption == 'delete') {
        this.$confirm('确定删除选中的商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.delprditem()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除商品',
            })
          })
      }
    },
    async delprditem() {
      // 执行审核
      this.distoryloading = true
      let { data, err } = await this.axiosApi(Desc.delprditem_api, {
        ids: this.actForm.id,
      })
      if (data && data.data && data.data.meta.status === 200) {
        this.getTableData()
        this.actForm.seloption = ''
        this.$message({
          type: 'success',
          message: data.data && data.data.data ? data.data.data : '',
          // offset: 61
        })
      } else {
        dealReturn(data, err)
      }
      this.distoryloading = false

      // await this.$http
      //   .post('delprditem', {
      //     ids: this.actForm.id,
      //   })
      //   .then((response) => {
      //     console.log(response)

      //     this.distoryloading = false
      //     this.this.getTableData()
      //     this.$message({
      //       message: '删除成功',
      //       type: 'success',
      //       showClose: true,
      //       duration: 3000,
      //     })
      //   })
      //   .catch((error) => {
      //     return this.$message.error(error.response.data.message)
      //   })
      this.distoryloading = false
    },
    handleSizeChange(val) {
      this.queryPrdlists.pagesize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.queryPrdlists.pagenum = val
      this.getTableData()
    },
    handleSearch() {
      // console.log("this.$refs", this.$refs)
      // 检测 数组字段 判断 两个数字的大小
      // if (this.form.payment) this.form.payment = [this.form.paymentLower, this.form.paymentUpper];
      this.queryPrdlists.param = Object.keys(this.form)
      this.queryPrdlists.query = JSON.parse(JSON.stringify(this.form))
      this.getTableData()
    },
    clearSearch() {
      this.form = {
        business: '',
        store: '',
        profession: '',
        spuCode: '',
        skuCode: '',
        title: '',
        category1: '',
        prdType: '',
      }
      this.actForm.seloption = ''

      console.log('clear', this.form)
      // if (this.platCode) this.platCode = '' // 像这样的 与页面强相关的东西，放到哪里可以考虑下
      // console.log('clearSearch this.form', this.form)
      this.handleSearch()
    },
    async getTableData() {
      this.queryPrdlists.param = Object.keys(this.form)
      this.queryPrdlists.query = JSON.parse(JSON.stringify(this.form))
      this.loading = true
      let { data, err } = await this.axiosApi(
        Desc.tradelist_api,
        this.queryPrdlists
      )
      // console.log("data", data);
      this.loading = false
      console.log('data', data)
      this.tableData = data.data.data.data
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
    // _isLarge(paymentUpper, paymentLower) {
    //   if (paymentUpper === "") paymentUpper = 0;
    //   if (paymentLower === "") paymentLower = 0;
    //   if (parseInt(paymentUpper) < parseInt(paymentLower)) {
    //     this.$message({
    //       type: "error",
    //       message: `下限不能大于上限`,
    //     });
    //     return false;
    //   }
    //   return true;
    // },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 22px;
}
// .pagation-card >>> {
// }
// .el-table {
//   height: calc(100vh - 100px);
// }
</style>


// WEBPACK FOOTER //
// src/views/rfm/rfmPrdList/index.vue